import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MuiChipsInput } from 'mui-chips-input';

const useStyles = makeStyles(theme => ({
    chip: {
        margin: theme.spacing(0.5, 0.25),
    },
}));

const validateEmail = email => {
    const re = new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    return {
        isError: !re.test(email),
        textError: 'Not a valid email address',
    };
};

export default function TagsInput(props) {
    const [selected, setSelected] = useState([]);

    const handleChange = newChips => {
        setSelected([...new Set(newChips)]);
        props.selectedTags([...new Set(newChips)]);
    };

    const handleInputChange = text => {
        if ([' ', ',', ';'].includes(text.at(-1))) {
            const interim = selected;
            interim.push(text.slice(0, -1));
            setSelected(interim);
        }
    };
    return (
        <MuiChipsInput
            addOnWhichKey={['Enter', ' ', ';', ',']}
            value={selected}
            onChange={handleChange}
            onInputChange={handleInputChange}
            validate={val => validateEmail(val)}
            label={props.label}
            placeholder={props.placeholder}
            data-cy={props['data-cy']}
        />
    );
}
